import { LeadInput } from './leadInput';

export class EditLeadInput {

  leadId: string;

  lead: LeadInput;
}
